/* eslint-disable indent */
import { APIs } from "../../utils/worker";
import API from "../../api";

const { bffBaseURL } = APIs;
const companyId =
  JSON.parse(localStorage.getItem("selectedCompany"))?.key || null;

const urls = {
  CREATE_LEAD: `${bffBaseURL}/on-boarding/v1/customer`,
  GET_NEAR_CP_LIST: `${bffBaseURL}/on-boarding/v1/customer/near-by-company`,
  GET_COMPANY_BY_CP: `${bffBaseURL}/on-boarding/v1/customer/company`,
  CUSTOMER_ENABLE_DISABLE: `${bffBaseURL}/on-boarding/v1/customer/enable/`,
  GET_CP_MASTER_LIST_V1: `${bffBaseURL}/on-boarding/cp/v1`,
  GET_CLIENT_MASTER_LIST_V1: `${bffBaseURL}/on-boarding/client-location/v1`,
  GET_COMPANY_MASTER_LIST_V1: `${bffBaseURL}/on-boarding/company/v1`,
  CHECK_EMAIL_AVAILABILITY: `${bffBaseURL}/on-boarding/v1/is-mail-available/`,
};

const handleApiRequest = async (
  url,
  method,
  data = null,
  headersMethod = "getWithUserNPremiseHeader"
) => {
  try {
    const payload =
      method === "putIdHeader" || (method === "put" && data)
        ? data
        : data
        ? { customer: data }
        : {};
    const headers =
      method === "postIdCustomHeader" && companyId
        ? { "COMPANY-ID": companyId }
        : headersMethod;

    const response = await API.Api(url)[method](payload, headers);
    return response;
  } catch (error) {
    console.error(`Error in ${method.toUpperCase()} request to ${url}:`, error);
    throw error;
  }
};

export const customerOnboardingAPI = {
  createLead: (payload) =>
    handleApiRequest(urls.CREATE_LEAD, "postIdCustomHeader", payload),

  patchLead: (id, payload) =>
    handleApiRequest(`${urls.CREATE_LEAD}/${id}`, "patchIdHeader", payload),

  patchCompany: (id, payload) =>
    handleApiRequest(
      `${urls.GET_COMPANY_MASTER_LIST_V1}/${id}`,
      "putIdHeader",
      payload
    ),

  putLead: (id, payload) =>
    handleApiRequest(`${urls.CREATE_LEAD}/approval`, "putIdHeader", payload),

  getAllLeadList: async (params) => {
    const queryParams = new URLSearchParams(params).toString();

    return handleApiRequest(
      `${urls.CREATE_LEAD}?${queryParams}`,
      "getWithUserNPremiseHeader"
    );
  },

  checkEmailAvailability: (email) =>
    handleApiRequest(
      `${urls.CHECK_EMAIL_AVAILABILITY}${email}`,
      "getWithToken"
    ),

  getAllLeadListWithoutPremise: async (params) => {
    const queryParams = new URLSearchParams(params).toString();

    return handleApiRequest(
      `${urls.CREATE_LEAD}?${queryParams}`,
      "getWithToken"
    );
  },

  getMasteList: async (params, url) => {
    const queryParams = new URLSearchParams(params).toString();

    return handleApiRequest(`${url}?${queryParams}`, "getWithToken");
  },

  putMaster: async (id, payload, url) => {
    return handleApiRequest(`${url}/${id}`, "putIdHeader", payload);
  },

  approveLeadCP: async (id, payload) => {
    return handleApiRequest(
      `${urls.CREATE_LEAD}/status-update/${id}`,
      "putIdHeader",
      payload
    );
  },

  activateAccount: async (id) => {
    return handleApiRequest(
      `${urls.CREATE_LEAD}/activate-cp/${id}`,
      "putIdHeader"
    );
  },

  // getCPList: async (params) => {
  //   const queryParams = new URLSearchParams(params).toString();

  //   return handleApiRequest(
  //     `${urls.GET_CP_MASTER_LIST_V1}?${queryParams}`,
  //     "getWithToken"
  //   );
  // },

  // getClientList: async (params) => {
  //   const queryParams = new URLSearchParams(params).toString();

  //   return handleApiRequest(
  //     `${urls.GET_CLIENT_MASTER_LIST_V1}?${queryParams}`,
  //     "getWithToken"
  //   );
  // },
  // getCompanyList: async (params) => {
  //   const queryParams = new URLSearchParams(params).toString();

  //   return handleApiRequest(
  //     `${urls.GET_COMPANY_MASTER_LIST_V1}?${queryParams}`,
  //     "getWithToken"
  //   );
  // },

  getLeadById: (id) =>
    handleApiRequest(`${urls.CREATE_LEAD}/${id}`, "getWithUserNPremiseHeader"),

  getNearestCpList: (pincode) =>
    handleApiRequest(`${urls.GET_NEAR_CP_LIST}/${pincode}`, "getWithToken"),

  getCompanyByCP: (params) => {
    const queryParams = new URLSearchParams(params).toString();

    return handleApiRequest(
      `${urls.GET_COMPANY_BY_CP}?${queryParams}`,
      "getWithToken"
    );
  },
  enableDisableCustomer: (id, payload) =>
    handleApiRequest(`${urls.CUSTOMER_ENABLE_DISABLE}${id}`, "put", payload),

  getMasterById: (id, url) => handleApiRequest(`${url}/${id}`, "getWithToken"),
};
